<template>
    <div class="offer-list">
        <div v-if="getData || getData && getData.quoteProducts.length > 0">
            <div class="title" v-if="getData.quoteProducts.length">识图产品列表（已识别{{getData.quoteProducts.length}}件）</div>
            <div class="item" v-for="(item,index) in getData.quoteProducts" :key="index">
                <div class="left">
                    <img :src="imgBaseUrl + item.partFiles[0].key" alt="">
                </div>
                <div class="right">
                    <div class="mate">
                        <span>产品名：</span>
                        <input type="text" v-model="item.name" maxlength="20">
                    </div>
                    <div class="mate">
                        <span>规   格：</span>
                        <input type="text" v-model="item.size" maxlength="20">
                    </div>
                   <div class="mate">
                        <span>定制要求：</span>
                        <input type="text" v-model="item.remark" maxlength="200" placeholder="请填写备注信息（200字以内）">
                    </div>
                    <div class="mate" @click="deleteProduct(index)">
                        <i class="iconfont icon-trash"></i>
                        删除产品
                    </div>
                </div>
            </div>

            <div class="choiced" v-if="getData.quoteProducts.length > 0">
                <Enquiry :lists="getData.quoteProducts"></Enquiry>
                
            </div>

        </div>

    </div>
</template>

<script>
    import api from '../../../api';
    import choiceList from '../../common/choiceList.vue'
    import Enquiry from './enquiry.vue'
    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                listData: null,
            };
        },
        computed: {
            getData(){
                return this.$store.state.app.manyImageListData
            },
            user() {
                return this.$store.state.user.info;
            },
        },
        components: {choiceList, Enquiry},
        methods: {
            deleteProduct(index){
                this.$store.dispatch('deleteManyImageList', index);
            },
            getChoicedListHandle(id){
                this.$emit('getList', id)
            },
            timeChange(value){
                if (!value) {
                    return '';
                }
                let d = new Date(value);
                let year = d.getFullYear();
                let month = '0' + (d.getMonth() + 1);
                let day = '0' + d.getDate();
                let hour = '0' + d.getHours() + '';
                let minutes = '0' + d.getMinutes() + '';
                let seconds = '0' + d.getSeconds() + '';
                return year + '-' + month.substr(-2, 2) + '-' + day.substr(-2, 2) + ' ' + hour.substr(-2, 2) + ':'
                    + minutes.substr(-2, 2) + ':' + seconds.substr(-2, 2);
            },
        },
        watch: {
        },
        created(){
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped type="text/scss">
    .offer-list {
        width: 100%;
        margin-top: 52px;
        margin-bottom: 58px;
        .title {
            font-size: 20px;
            color: #353838;
        }
        .item {
            margin-top: 20px;
            height: 160px;
            display: inline-block;
            width: 535px;
            vertical-align: top;
            .left {
                display: inline-block;
                width: 160px;
                height: 160px;
                border: 1px solid #ddd;
                font-size: 0px;
                text-align: center;
                line-height: 160px;
                vertical-align: middle;
                position: relative;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    vertical-align: middle;
                }
            }
            .right {
                display: inline-block;
                vertical-align: top;
                margin-left: 20px;
                width: 350px;
                .mate {
                    display: inline-block;
                    margin-bottom: 20px;
                    span {
                        display: inline-block;
                        width: 70px;
                        vertical-align: middle;
                        font-size: 14px;
                        color: #353838;
                    }
                    input {
                        display: inline-block;
                         width: 260px;
                        height: 30px;
                        padding: 0 17px;
                        border: none;
                        background: #EBEFF0;
                        font-size: 14px;
                        color: #353838;
                        vertical-align: middle;
                    }
                    &:last-child {
                        width: 30%;
                        float: right;
                        text-align: right;
                        font-size: 14px;
                        color: #6C6F70;
                        vertical-align: middle;
                        margin-top: -10px;
                        margin-right: 20px;
                        cursor: pointer;
                        i {
                            font-size: 16px;
                            color: #6C6F70;
                            margin-right: 6px;
                            vertical-align: top;
                        }
                        &:hover {
                            color: #353838;
                            i {
                                color: #353838;
                            }
                        }
                    }
                }
            }
            &:nth-child(odd) {
                margin-left: 60px;
            }
        }
        .choiced {
            margin-top: 45px;
            > span {
                font-size: 20px;
                color: #171A1A;
                margin-right: 12px;
                vertical-align: middle;
                .de {
                    font-size: 14px;
                    color: #E14B5D;
                    vertical-align: middle;
                }
            }
        }
    }
</style>

